export const SUBURBS = [
    {
        slug: "happy-valley",
        name: "Happy Valley",
        tag: "Our home base",
        blurb: "Our home base — you'll see the Lawn Busters trailer around Happy Valley more than anywhere else. Lawns, gardens, gutters, windows and junk removal, all taken care of by your actual neighbours.",
    },
    {
        slug: "flagstaff-hill",
        name: "Flagstaff Hill",
        tag: "Hillside blocks",
        blurb: "Sloped lawns and leafy streets keep hillside properties busy — mowing, edging, hedge trims and gutter cleaning for Flagstaff Hill homes, handled by a local team.",
    },
    {
        slug: "woodcroft",
        name: "Woodcroft",
        tag: "Family backyards",
        blurb: "Big backyards and growing gardens are the norm in Woodcroft. Regular mowing, weed removal and garden clean-ups to keep your block looking sharp year-round.",
    },
    {
        slug: "aberfoyle-park",
        name: "Aberfoyle Park",
        tag: "Foothills living",
        blurb: "Foothills living means leaves in the gutters and lawns that never stop growing. We service Aberfoyle Park with the full range — lawns, gutters, windows and junk removal.",
    },
    {
        slug: "hallett-cove",
        name: "Hallett Cove",
        tag: "Coastal care",
        blurb: "Sea air is tough on windows and gutters. We keep Hallett Cove properties clean and tidy — salt spray, sand and all — with window cleaning, gutter clearing and lawn care.",
    },
    {
        slug: "morphett-vale",
        name: "Morphett Vale",
        tag: "The south's biggest suburb",
        blurb: "One of the south's biggest suburbs and one of our busiest. From courtyards to full family blocks, Morphett Vale lawns and gardens are in good hands.",
    },
    {
        slug: "christies-beach",
        name: "Christies Beach",
        tag: "Beachside properties",
        blurb: "Beachside living deserves a tidy property to match. Lawn care, window cleaning, gutter clearing and junk removal for Christies Beach homes and rentals.",
    },
    {
        slug: "seaford",
        name: "Seaford",
        tag: "Coast & gardens",
        blurb: "From the Esplanade to the inland streets, we look after Seaford properties with mowing, garden clean-ups, window cleaning and junk removal — one team, one visit.",
    },
    {
        slug: "glenelg",
        name: "Glenelg",
        tag: "Bay-side tidy-ups",
        blurb: "Bay-side properties cop the salt and the sea breeze. We keep Glenelg homes and investment properties presentable with window cleaning, lawn care and tidy-ups.",
    },
];
